import {
  clearDeviceUnauthorized,
  reportDeviceUnauthorized
} from "./chunk-KVCLZREV.js";
import {
  signedFetch
} from "./chunk-2CSC3FHL.js";

// lib/api/loggedIn.ts
import {
  buildRedirectUri,
  isLoginUrl,
  navigator
} from "@lune/common/paths";
var ensureLoggedIn = (loginUrl) => (result) => {
  if (!result.ok) {
    if (result.status === 401) {
      console.log("Unauthorized. Redirecting to login.");
      if (isLoginUrl(loginUrl)) {
        window.location.assign(buildRedirectUri(loginUrl));
      } else {
        void navigator(loginUrl).then((e) => {
          e.navigate();
        });
      }
      const err = {
        name: "ensureLoggedInException",
        code: result.status,
        message: result.statusText
      };
      throw err;
    }
  }
  return result;
};
var ensureDeviceAuthorized = async (result) => {
  if (result.status === 401) {
    return result;
  }
  if (result.status !== 403) {
    clearDeviceUnauthorized();
    return result;
  }
  let deviceId;
  try {
    const body = await result.clone().json();
    deviceId = body.deviceId;
  } catch {
  }
  reportDeviceUnauthorized(deviceId);
  const err = {
    name: "ensureDeviceAuthorizedException",
    code: result.status,
    message: "Device not approved"
  };
  throw err;
};

// lib/api/auth.ts
import {
  apiUrlEndpointFactory,
  parseJsonResponse
} from "@lune/common/api";
import { logResults } from "@lune/common/logger";
import {
  navigator as navigator2
} from "@lune/common/paths";
var whoamiUrl = (version, root) => apiUrlEndpointFactory(version, root, "/auth/whoami").endpoint;
var logoutUrl = (version, root) => apiUrlEndpointFactory(version, root, "/auth/logout").endpoint;
var whoamiUrlForTestingOnly = whoamiUrl;
var logoutUrlForTestingOnly = logoutUrl;
var whoamiNotEnsured = (version, loginUrl, rootUrl) => async () => {
  return await signedFetch(whoamiUrl(version, rootUrl), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }).then(ensureDeviceAuthorized).then(async (result) => await parseJsonResponse(result)).then((result) => result.item).then(logResults("whoami:user"));
};
var whoami = (version, loginUrl, rootUrl) => async () => {
  return await signedFetch(whoamiUrl(version, rootUrl), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }).then(ensureLoggedIn(loginUrl)).then(ensureDeviceAuthorized).then(async (result) => await parseJsonResponse(result)).then((result) => result.item).then(logResults("whoami:user"));
};
var logout = (version, loginUrl, rootUrl) => async () => {
  return await signedFetch(logoutUrl(version, rootUrl), {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }).then(async () => await navigator2(loginUrl));
};
var builder = (version, loginUrl, rootUrl) => ({
  logout: logout(version, loginUrl, rootUrl),
  whoami: whoami(version, loginUrl, rootUrl),
  whoamiNotEnsured: whoamiNotEnsured(version, loginUrl, rootUrl)
});
var withVersion = async (version, loginUrl, rootUrl) => builder(version, loginUrl, rootUrl);

export {
  ensureLoggedIn,
  ensureDeviceAuthorized,
  whoamiUrlForTestingOnly,
  logoutUrlForTestingOnly,
  withVersion
};
